import { Contact } from "pages/contact/contact";
import { DataPrivacy } from "pages/data-privacy/data-privacy";
import React, { VFC } from "react";
import { Redirect, Switch } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useAuthContext } from "../providers/Auth/auth.provider";
import { AuthenticatedRoute } from "../utils/AuthenticatedRoute";
import { AvailableBaseRoutes } from "../utils/constants";
import {
  isAdmin,
  isPomAgency,
  isPomMainContact,
  IUser,
} from "../domain/user/user";
import { GroupRoutes } from "./groups/group.routes";
import { UsersRoutes } from "./users/users.routes";

export const BaseRoutes: VFC = () => {
  const { internalUser } = useAuthContext();

  const canSeeBaseDataRoutes = (user: IUser | undefined) => {
    return (
      isAdmin(user) || isPomMainContact(user) || isPomAgency(user)
    );
  };

  return (
    <Switch>
      {/* contact & Data-Privacy */}
      <AuthenticatedRoute path={AvailableBaseRoutes.Contact} component={() => <Contact key={uuidv4()} />} />
      <AuthenticatedRoute path={AvailableBaseRoutes.DataPrivacy} component={() => <DataPrivacy key={uuidv4()} />} />

      {canSeeBaseDataRoutes(internalUser) && (
        <>
          <AuthenticatedRoute
            path={AvailableBaseRoutes.Group}
            allowedConditionCallback={isPomMainContact}
          >
            <GroupRoutes />
          </AuthenticatedRoute>

          <AuthenticatedRoute path={AvailableBaseRoutes.UserList}>
            <UsersRoutes />
          </AuthenticatedRoute>
        </>
      )}

      <Redirect path={"*"} to={AvailableBaseRoutes.Portal} push />
    </Switch>
  );
};
